import { render, staticRenderFns } from "./BasicSetting.vue?vue&type=template&id=ef391cba&scoped=true"
import script from "./BasicSetting.vue?vue&type=script&lang=js"
export * from "./BasicSetting.vue?vue&type=script&lang=js"
import style0 from "./BasicSetting.vue?vue&type=style&index=0&id=ef391cba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef391cba",
  null
  
)

export default component.exports